import { render, staticRenderFns } from "./TestPicForm.vue?vue&type=template&id=db1e8d08"
import script from "./TestPicForm.vue?vue&type=script&lang=js"
export * from "./TestPicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1e8d08')) {
      api.createRecord('db1e8d08', component.options)
    } else {
      api.reload('db1e8d08', component.options)
    }
    module.hot.accept("./TestPicForm.vue?vue&type=template&id=db1e8d08", function () {
      api.rerender('db1e8d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/pic/TestPicForm.vue"
export default component.exports